import { type ReactNode } from 'react'

type AuthFormShellProps = {
	title: string
	description?: ReactNode
	children: ReactNode
}

export function AuthFormShell({
	title,
	description,
	children,
}: AuthFormShellProps) {
	return (
		<div className="flex min-h-full flex-col justify-center pt-20 pb-32">
			<div className="mx-auto w-full max-w-md">
				<div className="flex flex-col gap-3 text-center">
					<h1 className="text-h1">{title}</h1>
					{description ? (
						<p className="text-body-md text-muted-foreground">{description}</p>
					) : null}
				</div>

				<div className="mx-auto mt-16 w-full max-w-md px-8">{children}</div>
			</div>
		</div>
	)
}
